import { useState } from "react";
import { Mail, Pencil, Phone, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/crm/Badges";

const FIELDS = [["first_name", "Nombre"], ["last_name", "Apellido"], ["phone", "Teléfono"], ["email", "Correo"]];

export const PersonalDataPanel = ({ lead, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [v, setV] = useState({});
  const start = () => { setV(Object.fromEntries(FIELDS.map(([k]) => [k, lead[k] || ""]))); setEditing(true); };
  const save = async () => {
    const patch = { ...v, email: v.email || null };
    if (await onUpdate(patch)) setEditing(false);
  };

  return (
    <Panel title="Datos personales" icon={User} testid="lead-personal-panel"
           action={!editing && <Button variant="ghost" size="sm" onClick={start} className="h-8 rounded-lg" data-testid="edit-personal-button"><Pencil className="mr-1 h-3.5 w-3.5" /> Editar</Button>}>
      {editing ? (
        <div className="space-y-3">
          {FIELDS.map(([k, label]) => (
            <Input key={k} value={v[k]} placeholder={label} onChange={(e) => setV((s) => ({ ...s, [k]: e.target.value }))} className="h-10 rounded-xl" data-testid={`personal-input-${k}`} />
          ))}
          <div className="flex gap-2">
            <Button onClick={save} disabled={!v.first_name?.trim() || !v.phone?.trim()} className="flex-1 rounded-xl bg-[#1E6FD9]" data-testid="save-personal-button">Guardar</Button>
            <Button variant="outline" onClick={() => setEditing(false)} className="rounded-xl" data-testid="cancel-personal-button">Cancelar</Button>
          </div>
        </div>
      ) : (
        <dl className="space-y-3 text-sm">
          <div className="flex items-center gap-3"><User className="h-4 w-4 text-slate-400" /><span className="font-semibold" data-testid="lead-full-name">{lead.full_name}</span></div>
          <div className="flex items-center gap-3"><Phone className="h-4 w-4 text-slate-400" /><a href={`tel:${lead.phone}`} className="hover:text-[#1E6FD9]" data-testid="lead-phone">{lead.phone}</a></div>
          <div className="flex items-center gap-3"><Mail className="h-4 w-4 text-slate-400" /><span className="break-all" data-testid="lead-email">{lead.email || "—"}</span></div>
        </dl>
      )}
    </Panel>
  );
};
